import useGetFile from '@/hooks/use-get-file';
import { useParams } from 'react-router';

interface Props {
    tag: string;
    children: any;
}

const GetDocumentContainer = ({ tag, children }: Props) => {
    const { placeId, siteId, clientId } = useParams();

    const {
        file,
        isLoading: isLoadingFile,
        refetch,
    } = useGetFile({
        resource: 'avatar',
        resourceId: placeId ?? siteId ?? clientId,
        tagsName: [tag],
    });

    return children({
        file,
        isLoadingFile: isLoadingFile,
        refetch,
    });
};

export default GetDocumentContainer;
